import { createSlice } from '@reduxjs/toolkit';

const ticketSlice = createSlice({
  name: 'tickets',
  initialState: {
    tickets: [],
    loading: false,
    error: null
  },
  reducers: {
    fetchTicketsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchTicketsSuccess(state, action) {
      state.tickets = action.payload;
      state.loading = false;
    },
    fetchTicketsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addNoteToTicket(state, action) {
      const { ticketId, note } = action.payload;
      const ticketIndex = state.tickets.findIndex(t => t._id === ticketId);
      if (ticketIndex !== -1) {
        state.tickets[ticketIndex].notes = [
          ...state.tickets[ticketIndex].notes,
          { message: note }
        ];
      }
    }
  }
});

export const {
  fetchTicketsStart,
  fetchTicketsSuccess,
  fetchTicketsFailure,
  addNoteToTicket
} = ticketSlice.actions;

export default ticketSlice.reducer;